module.exports = __webpack_public_path__ + "img/slide-arrow.acde5503.svg";